<template>
  <div>
    <iframe-detail :url="url" />
  </div>
</template>

<script>
import IframeDetail from '@/components/iframe/iframe-detail'
export default {
  components: {
    IframeDetail
  },
  data() {
    return {
      url: `${process.env.BASE_URL}contract/newcontract.html?base_data_url=${process.env.VUE_APP_BASE_DATA_API}&contract_url=${process.env.VUE_APP_CONTRACT_API}&base_url=${process.env.VUE_APP_BASE_API}`
    }
  }
}
</script>
